import { render, staticRenderFns } from "./ReconciliationMatchCard.vue?vue&type=template&id=60185110&scoped=true&"
import script from "./ReconciliationMatchCard.vue?vue&type=script&lang=js&"
export * from "./ReconciliationMatchCard.vue?vue&type=script&lang=js&"
import style0 from "./ReconciliationMatchCard.vue?vue&type=style&index=0&id=60185110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60185110",
  null
  
)

export default component.exports